import {Modal, Button} from '@goproblems/ui';
import {useTranslation} from 'react-i18next';

type PatternSearchHelpModalProps = {
    show: boolean;
    onHide: () => void;
};

export const PatternSearchHelpModal = ({
    show,
    onHide,
}: PatternSearchHelpModalProps) => {
    const {t} = useTranslation();

    return <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
            <Modal.Title>{t('pattern_search_help.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>{t('pattern_search_help.introduction')}</p>
            <p>{t('pattern_search_help.performance')}</p>
            <p>{t('pattern_search_help.scope')}</p>
            <p>{t('pattern_search_help.intersections')}</p>
            <p>{t('pattern_search_help.shortcuts')}</p>
            <p>{t('pattern_search_help.full_side')}</p>
            <p>{t('pattern_search_help.minimum')}</p>
            <p>{t('pattern_search_help.example_intro')}</p>
            <div className="text-center">
                <img
                    src="/img/help/prob_19246_example.png"
                    className="img-thumbnail"
                    alt={t('pattern_search_help.example_problem_alt')}
                />
            </div>
            <br />
            <br />
            <p>{t('pattern_search_help.example_search_intro')}</p>
            <div className="text-center">
                <img
                    src="/img/help/search_example.png"
                    className="img-thumbnail"
                    alt={t('pattern_search_help.example_search_alt')}
                />
            </div>
            <br />
            <br />
            <p>{t('pattern_search_help.example_note')}</p>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" size="sm" onClick={onHide}>
                {t('common.got_it')}
            </Button>
        </Modal.Footer>
    </Modal>;
};
